import React, { useEffect, useState } from "react";
import app from "../util/firebase";
import {
  getDatabase,
  ref,
  set,
  update,
  push,
  orderByChild,
  equalTo,
  query,
  remove,
  onValue,
  setPriority,
  orderByPriority,
} from "firebase/database";
// eslint-disable-next-line
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DateTimePicker from "@mui/lab/DateTimePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
// eslint-disable-next-line
import relativeTime from "dayjs/plugin/relativeTime";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Tooltip from "@mui/material/Tooltip";
import {
  Button,
  Dialog,
  IconButton,
  Slide,
  TextField,
  Grid,
  Card,
  CardActions,
  CardContent,
  DialogTitle,
  DialogContent,
  DialogContentText,
  useMediaQuery,
  CircularProgress,
  LinearProgress,
  DialogActions,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { async } from "@firebase/util";

function time(date) {
  return date.getTime();
}
function formatDue(date) {
  // console.log("date object" + date);
  // console.log(date.getTime());
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return (
    date.getMonth() +
    1 +
    "/" +
    date.getDate() +
    "/" +
    date.getFullYear() +
    "  " +
    strTime
  );
}

function formatDate(date) {
  return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
}

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  // toolbar: theme.mixins.toolbar,
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  submitButton: {
    display: "block",
    color: "white",
    textAlign: "center",
    position: "absolute",
    top: 14,
    right: 10,
  },
  floatingButton: {
    position: "fixed",
    bottom: 0,
    right: 240,
  },
  form: {
    width: "98%",
    marginLeft: 13,
    marginTop: theme.spacing(14),
  },
  toolbar: theme.mixins.toolbar,
  root: {
    minWidth: 470,
    margin: 24,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  pos: {
    marginBottom: 12,
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
  dialogeStyle: {
    maxWidth: "50%",
  },
  viewRoot: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  cardActions: {
    marginLeft: "auto",
    // "&:hover": {
    color: "primary",
    // },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const db = getDatabase(app);
query(ref(db, "da6d/" + "tasks"), orderByChild("dueTime"));
export default function Tasks() {
  // var tasksData = props.data;
  // var counter = props.counter;
  const db = getDatabase(app);
  // const tasksRef = query(ref(db, "da6d/" + "tasks"), setPriority("dueTime", onComplete ?: (a: Error | null) => any));

  // const newTasksRef = query(ref(db, "da6d/" + "tasks"));
  // const tasksRef = setPriority(ref(db, "da6d/" + "tasks"), "dueTime");
  //order by priority
  const tasksRef = query(ref(db, "da6d/" + "tasks"), orderByPriority());
  //test priority
  // onValue(tasksRef, (snapshot) => {
  //   // snapshot.setPriority("dueTime");
  //   snapshot.forEach((childSnapshot) => {
  //     //test if priority is set
  //     console.log(childSnapshot.exportVal());
  //   });
  // });
  // tasksRef.orderByPriority();

  // const newTasksRef = query(ref(db, "da6d/" + "tasks"));
  // const tasksRef = query(
  //   ref(db, "da6d/" + "tasks"),
  //   setPriority(newTasksRef, "dueTime")
  // );
  // onValue(tasksRef, (snapshot) => {
  //   snapshot.forEach((childSnapshot) => {
  //     childSnapshot.getPriority();
  //   });
  // });
  // console.log("testPriority" + tasksRef);
  // const tasksRef = query(newTasksRef2, orderByPriority());
  // query(tasksRef, orderByChild("dueTime"));
  // query(tasksRef, orderByChild("dueTime"));

  // const tasksRef = query(
  //   ref(db, "da6d/" + "tasks"),
  //   setPriority(ref(db, "da6d/" + "tasks"), "dueTime")
  // );

  var counter = 0;
  // var loading = true;
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  var taskArr = [];
  var counter = 0;
  const [todos, setTodos] = useState([taskArr]);
  const [title, setTitle] = useState("");
  // const [body, setBody] = useState("");
  const [due, setDue] = useState(null);
  const [todoId, setTodoid] = useState(null);
  const [buttonType, setButtonType] = useState("");
  const [open, setOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [status, setStatus] = useState(0);
  const [completeCount, setCompleteCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  // const [input, setInput] = useState('');

  const handleChangeTitle = (event) => {
    setTitle(event.target.value);
  };
  // const handleChangeBody = (event) => {
  //   setBody(event.target.value);
  // };

  const handleChangeDue = (due) => {
    setDue(due);
  };

  const totalCountRef = query(ref(db, "da6d/" + "totalCount"));
  const completeCountRef = query(ref(db, "da6d/" + "completeCount"));
  const da6dRef = query(ref(db, "da6d"));

  useEffect(() => {
    setLoading(true);
    query(ref(db, "da6d/" + "tasks"), orderByPriority());
    onValue(tasksRef, (snapshot) => {
      taskArr.length = 0;
      counter = 0;
      snapshot.forEach((childSnapshot) => {
        query(ref(db, "da6d/" + "tasks"), orderByPriority());
        taskArr.push(childSnapshot.val());
        if (childSnapshot.val()["status"] == 2) {
          counter++;
        }
        // console.log("key is " + childSnapshot.key);

        // if (
        //   childSnapshot.val()["status"] != 2 &&
        //   childSnapshot.val()["status"] != 3 &&
        //   new Date(new Date().getTime() + 60 * 60 * 1000).getTime() >
        //     childSnapshot.val()["dueTime"] &&
        //   childSnapshot.val()["dueTime"] > new Date().getTime()
        // ) {
        //   const theref = query(ref(db, "da6d/" + "tasks/" + childSnapshot.key));
        //   update(theref, { status: 3 });
        //   // query(ref(db, "da6d/" + "tasks/" + data.todoId));
        //   // // childSnapshot.val()["status"] = 3;
        //   // console.log(
        //   //   "1 hour later " +
        //   //     new Date(new Date().getTime() + 60 * 60 * 1000).getTime()
        //   // );
        //   // console.log("due          " + childSnapshot.val()["dueTime"]);
        //   // console.log("now          " + new Date().getTime());
        //   console.log("TEST CHANGE");
        // }
      });
      // query(ref(db, "da6d/" + "tasks"), orderByPriority());
      setTotalCount(taskArr.length);
      setCompleteCount(counter);
      setTodos(taskArr);
      setLoading(false);
      // console.log(taskArr);
    });

    onValue(totalCountRef, (snapshot) => {
      // console.log(snapshot.val());
      setTotalCount(snapshot.val());
    });

    onValue(completeCountRef, (snapshot) => {
      setCompleteCount(snapshot.val());
    });
    // return () => {
    //   setTotalCount();
    //   setCompleteCount();
    //   setTodos();
    //   setLoading();
    //   setTotalCount();
    // };
  }, []);

  const deleteTodoHandler = (data) => {
    // tasksData = tasksData.filter((el) => el.todoId !== data.todoId); //should set to match id
    const newTotalCount = totalCount - 1;
    const newCompleteCount = completeCount - 1;
    const taskRef = query(ref(db, "da6d/" + "tasks/" + data.todoId));
    // update(taskRef, { status: !data.status });
    update(da6dRef, { update: true });
    setLoading(true);
    setTotalCount(newTotalCount);
    update(da6dRef, { totalCount: newTotalCount });
    if (data.status == 2) {
      setCompleteCount(newCompleteCount);
      update(da6dRef, { completeCount: newCompleteCount });
    }
    remove(taskRef);

    // window.location.reload();
    console.log(todos);
    // setLoading(true);
  };

  const completeHandler = (data) => {
    const taskRef = query(ref(db, "da6d/" + "tasks/" + data.todoId));
    var newCompleteCount;
    setLoading(true);
    update(da6dRef, { update: true });
    if (data.status == 2) {
      update(taskRef, { status: 0 });
      setStatus(0);
      newCompleteCount = completeCount - 1;
      setCompleteCount(newCompleteCount);
    } else {
      update(taskRef, { status: 2 });
      setStatus(2);
      newCompleteCount = completeCount + 1;
      setCompleteCount(newCompleteCount);
    }
    update(da6dRef, { completeCount: newCompleteCount });
    // window.location.reload();
  };

  const handleEditClickOpen = (data) => {
    setTitle(data.title);
    // setBody(data.body);
    setDue(data.due);
    setTodoid(data.todoId);
    setStatus(data.status);
    setButtonType("Edit");
    setOpen(true);
  };

  // const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleViewOpen = (data) => {
    setTitle(data.title);
    setStatus(data.status);
    // setBody(data.body);
    setDue(new Date(data.due));
    setTodoid(data.todoId);
    setViewOpen(true);
  };

  const submitHandler = (event) => {
    // authMiddleWare(this.props.history);
    // const taskRef = firebase.database().ref("Task");

    // const dbRef = ref('/tasks');
    event.preventDefault();
    // console.log(due);
    const userTodo = {
      title: title,
      // body: body,
      // due: formatDue(due),
      dueTime: new Date(due).getTime(),
      dueDate: formatDate(new Date(due)),
      due: formatDue(new Date(due)),
      status: status,
      // todoId: buttonType === "Edit" ? todoId : counter++,
      todoId: buttonType === "Edit" ? todoId : null,
    };
    update(da6dRef, { update: true });
    if (buttonType === "Edit") {
      // edit task in database;
      // var foundIndex = tasksData.findIndex((x) => x.todoId === todoId);
      const taskRef = query(ref(db, "da6d/" + "tasks/" + todoId));
      //set dueTime as priority goes here
      setPriority(taskRef, userTodo.dueTime);
      update(taskRef, userTodo);
      query(ref(db, "da6d/" + "tasks"), orderByPriority());
      // const dbRef = ref(db, "tasks}");
      // update(dbRef, userTodo);

      // tasksData[foundIndex] = userTodo;
      setOpen(false);
      // console.log(tasksData);
      // console.log(buttonType);
    } else {
      //add task to database
      // console.log(userTodo);
      // tasksData.push(userTodo);
      const taskListRef = ref(db, "da6d/" + "tasks");
      const newTaskRef = push(taskListRef);
      const newTaskRefKey = newTaskRef.key;
      userTodo.todoId = newTaskRefKey;
      set(newTaskRef, userTodo);
      //set dueTime as priority goes here
      setPriority(newTaskRef, userTodo.dueTime);
      query(ref(db, "da6d/" + "tasks"), orderByPriority());
      const newTotalCount = totalCount + 1;
      // update(taskRef, { status: !data.status });
      setTotalCount(newTotalCount);
      update(da6dRef, { totalCount: newTotalCount });

      setOpen(false);
      // counter++;
      // console.log(tasksData);
      // console.log(buttonType);
    }
  };

  const closeHandler = (event) => {
    setOpen(false);
  };

  const viewCloseHandler = (event) => {
    setViewOpen(false);
  };
  const mouseOverCardActionsHandler = (event) => {
    event.target.style.color = "#1E3877";
  };
  const mouseOutCardActionsHandler = (event) => {
    event.target.style.color = null;
  };
  const handleClickOpen = () => {
    if (totalCount >= 14) {
      alert("Task Count Reaches Maximum");
      return;
    }
    setTitle("");
    // setBody("");
    setTodoid("");
    setButtonType("");
    setStatus(0);
    setDue(new Date());
    // setDue(null);
    setOpen(true);
  };

  return loading ? (
    <div>
      <LinearProgress />
    </div>
  ) : (
    <div>
      <Tooltip title="Add a task.">
        <IconButton
          className={classes.floatingButton}
          color="primary"
          aria-label="Add Todo"
          onClick={handleClickOpen}
        >
          <AddCircleIcon style={{ fontSize: 60 }} />
        </IconButton>
      </Tooltip>
      <Grid container spacing={3}>
        {todos
          .sort((a, b) => a.dueTime - b.dueTime)
          .map(
            (
              task //should set key
            ) => (
              <Grid item xs={12} sm={6} md={4}>
                <Paper>
                  <Card
                    variant="outlined"
                    sx={{
                      ":hover": {
                        boxShadow: 10,
                        color: "#1E3877",
                        // transform: "scale(1.02)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="h5"
                        component="h2"
                        sx={{
                          textDecoration:
                            task.status == 2 ? "line-through" : null,
                        }}
                      >
                        {task.title.length > 28
                          ? task.title.substring(0, 27) + "..."
                          : task.title}
                      </Typography>
                      <Typography color="textSecondary">
                        {/* {dayjs(task.createdAt).fromNow()} */}
                      </Typography>
                      {/* <Divider /> */}
                      <Typography
                        variant="body2"
                        component="p"
                        align="right"
                        color="textSecondary"
                      >
                        Due at {`${formatDue(new Date(task.due))}`}
                        {/* Due at {task.due} */}
                        {/* Due at {`${task.due.toString()}`} */}
                      </Typography>
                      {/* <Typography
                        variant="body1"
                        component="p"
                        sx={{
                          textDecoration: task.status ? "line-through" : null,
                        }}
                      >
                        {`${task.body.substring(0, 65)}`}
                      </Typography> */}
                    </CardContent>
                    <CardActions>
                      <Tooltip title="Mark as completed/incomplete.">
                        <IconButton
                          className={classes.cardActions}
                          size="small"
                          onMouseOver={mouseOverCardActionsHandler}
                          onMouseOut={mouseOutCardActionsHandler}
                          onClick={() => completeHandler(task)}
                        >
                          {task.status == 2 ? (
                            <CheckBoxIcon />
                          ) : (
                            <CheckBoxOutlineBlankIcon />
                          )}
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="View details.">
                        <IconButton
                          className={classes.cardActions}
                          size="small"
                          // color="primary"
                          // onClick={handleViewOpen({ task })}
                          // handleViewOpen
                          onMouseOver={mouseOverCardActionsHandler}
                          onMouseOut={mouseOutCardActionsHandler}
                          onClick={() => handleViewOpen(task)}
                          sx={{
                            marginLeft: "auto",
                            // "&:hover": {
                            color: "primary",
                            // },
                          }}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Edit the task.">
                        <IconButton
                          className={classes.cardActions}
                          size="small"
                          // color="primary"
                          onMouseOver={mouseOverCardActionsHandler}
                          onMouseOut={mouseOutCardActionsHandler}
                          onClick={() => handleEditClickOpen(task)}

                          // onClick={handleEditClickOpen({ task })}
                        >
                          <BorderColorIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete the task.">
                        <IconButton
                          className={classes.cardActions}
                          size="small"
                          onMouseOver={mouseOverCardActionsHandler}
                          onMouseOut={mouseOutCardActionsHandler}
                          onClick={() => deleteTodoHandler(task)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </CardActions>
                  </Card>
                </Paper>
              </Grid>
            )
          )}
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}></Grid>
        </Grid>
      </Grid>
      <Dialog
        fullScreen
        open={open}
        onClose={closeHandler}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={closeHandler}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {buttonType === "Edit" ? "Edit Task" : "Create A New Task"}
            </Typography>
            <Button
              autoFocus
              color="inherit"
              onClick={submitHandler}
              className={classes.submitButton}
              sx={{
                display: "block",
                color: "white",
                textAlign: "center",
                position: "absolute",
                top: 14,
                right: 10,
              }}
            >
              {buttonType === "Edit" ? "Save" : "Submit"}
            </Button>
          </Toolbar>
        </AppBar>

        <form className={classes.form} noValidate>
          <Grid container spacing={8}>
            {/* <Grid item xs={12} md={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="todoTitle"
                label="Task Title"
                name="title"
                autoComplete="todoTitle"
                // helperText={errors.title}
                value={title}
                // error={errors.title ? true : false}
                onChange={handleChangeTitle}
              />
            </Grid> */}
            <Grid item xs={12} md={12}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  renderInput={(params) => (
                    <TextField required fullWidth {...params} />
                  )}
                  label="Task Due Date&Time picker"
                  value={new Date(due)}
                  onChange={(newValue) => {
                    setDue(newValue);
                  }}
                  // minDateTime={new Date()}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={12}>
              <TextField
                variant="filled"
                required
                fullWidth
                id="todoTitle"
                label="Add Note"
                name="title"
                autoComplete="todoDetails"
                multiline
                rows={40}
                // helperText={errors.body}
                // error={errors.body ? true : false}
                onChange={handleChangeTitle}
                value={title}
              />
            </Grid>
          </Grid>
        </form>
      </Dialog>
      <Dialog
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        open={viewOpen}
        onMouseOver={mouseOverCardActionsHandler}
        onMouseOut={mouseOutCardActionsHandler}
        onClose={viewCloseHandler}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          {status == 2 ? "Completed Task" : "Task needs to do"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {title}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <IconButton onClick={viewCloseHandler} autoFocus>
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
